/* global UserProfileURL */

import _ from 'topmeteo/utils/i18n';

import TranslatedLink from './TranslatedLink';

const UnauthorizedMessage = _('WeGlide connection is expired or revoked. Please go to your <a>user profile</a> to reconnect your accounts.');
const UnavailableMessage = _('WeGlide is currently unavailable. Please try again later.');
const UnknownMessage = _('An unknown error has occurred. Please try again later.');

const WeGlideError = ({error}) => {
    switch (error.status) {
        case 401:
            return <TranslatedLink className="unauthorized" message={UnauthorizedMessage} href={UserProfileURL} />;
        case 503:
            return <p className="unavailable">{UnavailableMessage}</p>;
        default:
            return <p className="unknown">{UnknownMessage}</p>;
    }
};

const WeGlideErrorContainer = ({error}) => (
    <div className="error">
        <WeGlideError error={error} />
    </div>
);

export default WeGlideErrorContainer;
